<mat-card *ngIf="isLocationContextValid">
    <mat-card-content>
        <div class="container">
            <div class="location-context">
                <div class="message">
                    <span class="location centerline" data-cy="selected-centerline" *ngIf="!onMaintenancePage">
                        Centerline {{ selectedCenterline }}
                    </span>
                    <span class="location device" data-cy="selected-device" *ngIf="onMaintenancePage">
                        Device {{ selectedDevice }}
                    </span>
                </div>
                <div class="button">
                    <button class="home" mat-raised-button color="secondary" (click)="redirectHome()" data-cy="home">
                        <mat-icon>home</mat-icon>Home
                    </button>
                </div>
                <div class="button" *ngIf="isUpButtonAvailable()">
                    <button class="up" mat-raised-button color="secondary" (click)="redirectUp()" data-cy="up">
                        <mat-icon>arrow_upward</mat-icon>Up
                    </button>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>
